import { Title } from '@patternfly/react-core'
import { TableComposable, Tbody, Tr, Th, Td } from '@patternfly/react-table'
import * as React from 'react'

import { convertDerivedValueToDisplay } from '@app/domain/derived-values/derived-values.helpers'

interface Props {
  derivedValues?: Record<string, unknown>
}

export const DerivedValuesTable = ({ derivedValues }: Props) => {
  return (
    <>
      <Title headingLevel="h1">Derived Values</Title>
      {derivedValues && Object.keys(derivedValues).length ? (
        <TableComposable
          aria-label="Sticky columns and header table"
          gridBreakPoint=""
          isStickyHeader
          isStriped
          borders={false}
          style={{ tableLayout: 'auto' }}
        >
          <Tbody>
            {Object.keys(derivedValues).map((key: string) => {
              return (
                <Tr key={key}>
                  <Th isStickyColumn modifier="wrap" width={10}>
                    {key}
                  </Th>
                  <Td width={10} modifier="wrap" key={key}>
                    {convertDerivedValueToDisplay(derivedValues[key])}
                  </Td>
                </Tr>
              )
            })}
          </Tbody>
        </TableComposable>
      ) : (
        <>There are no derived values for this visit.</>
      )}
    </>
  )
}
